// extracted by mini-css-extract-plugin
export default {"topicTitleSmall":"index_topicTitleSmall_obUmh","title_logo":"index_title_logo_LtkG-","title":"index_title_cf9ro"};